import React from 'react';
import { Tooltip as BlueprintTooltip, ITooltipProps } from '@blueprintjs/core';

const Tooltip = ({
  modifiers = {
    offset: {
      enabled: true,
      offset: '0, 2px'
    }
  },
  ...props
}: ITooltipProps) => <BlueprintTooltip modifiers={modifiers} {...props} />;

export default Tooltip;
